/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:711px) and (max-width:990px){.certificates-wrapper[_ngcontent-%COMP%]{min-width:unset;width:100%}.container.progress-page-container-wrapper[_ngcontent-%COMP%]{width:92%;max-width:940px}}@media (max-width:710px){.certificates-wrapper[_ngcontent-%COMP%]{width:100%}}"];
export { styles as styles };
//# sourceMappingURL=certificates-section.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/progress/certificates-section/certificates-section.component.scss.shim.ngstyle.js
// module id = 1675
// module chunks = 27 28 29